import { ArrowBack } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import * as React from 'react';

interface BackButtonProps {
    title: string;
    marginBottom?: string;
    id?: string;
    onBack: () => void;
}

export const BackButton = ({
    onBack,
    title,
    marginBottom = '16px',
    id = undefined,
}: BackButtonProps) => {
    return (
        <Button
            id={id}
            onClick={onBack}
            startIcon={<ArrowBack sx={{ width: '24px', height: '24px' }} />}
            sx={{
                justifyContent: 'flex-start',
                color: 'rgba(0,0,0,0.5)',
                p: 0,
                mb: marginBottom,
                textTransform: 'inherit',
                ':hover': {
                    bgcolor: 'transparent',
                },
                '.MuiButton-startIcon': {
                    ml: 0,
                },
            }}
        >
            <Typography variant="body2">{title}</Typography>
        </Button>
    );
};
